import { Locale } from 'vue-i18n';
import { extend } from 'vee-validate';
import { required, email, regex, max } from 'vee-validate/dist/rules';
import i18n from '@/plugins/i18n';

export const initializeValidators: (language: Locale) => void = language => {
  extend('required', {
    ...required,
    message: i18n.t('FORM.VALIDATION.ERROR.REQUIRED', language).toString(),
  });

  extend('email', {
    ...email,
    message: i18n.t('FORM.VALIDATION.ERROR.EMAIL', language).toString(),
  });

  extend('max', {
    ...max,
    message: i18n.t('FORM.VALIDATION.ERROR.TOO_MANY_CHARACTERS', language).toString(),
  });

  extend('regex', {
    ...regex,
    message: i18n.t('FORM.VALIDATION.ERROR.PHONE_NUMBER', language).toString(),
  });

  extend('time_format', {
    validate: value => {
      const regex = /^\d{1,2}:[0-5]\d$/;
      return regex.test(value);
    },
    message: i18n.t('FORM.VALIDATION.ERROR.TIME_FORMAT', language).toString(),
  });
};
